module.exports = __webpack_public_path__ + "img/play-button-mobiel.59550003bf14162f84271b418750b6cb.svg";